module.exports = __webpack_public_path__ + "static/media/background-home-hero.8cbe5f13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-home-hero.jpg
// module id = 543
// module chunks = 0